import { render } from "./button.vue?vue&type=template&id=5350d404"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/button/button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5350d404"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5350d404', __exports__)) {
    api.reload('5350d404', __exports__)
  }
  
  module.hot.accept("./button.vue?vue&type=template&id=5350d404", () => {
    api.rerender('5350d404', render)
  })

}


export default __exports__